"use client";
import React from "react";
import HeroSimple from "@/library/sections/heroes/HeroSimple";

export default function HeroSimpleBlock({ blok }) {
  const mappedImages =
    blok.images?.map((img) => ({
      src: img.filename,
      alt: img.alt || "Hero image",
      filename: img.filename,
    })) || [];

  return (
    <HeroSimple
      blok={blok}
      title={blok.title}
      titleAs={blok.titleAs}
      images={mappedImages}
    />
  );
}
